import { Helmet } from "react-helmet-async";
import { openPopup } from "../../../store/popupSlice"
import { useDispatch } from "react-redux";
import Breadcrumb from "../../../component/Breadcrumb";
import React from "react";

export default function BlaBlaHead({data, isCareem=false}) {
  const dispatch = useDispatch();
  if (!data) {
    return null;
  }
  return (
    <>
      <Helmet>
        <link rel="preload" href={data.image} as="image" type="image/webp"/>
        <link rel="preload" href={data.backImage} as="image" type="image/webp"/>
      </Helmet>
      <section className="blabla-head-area header-gap" style={{backgroundImage : `url(${data.backImage})`}}>
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-lg-6 col-md-6">
              <div className={`blabla-head-content ${isCareem? "lyftclone-banner-head" :""}`}>
                <Breadcrumb breadcrumbData={data?.breadcrumbData}/>
                {isCareem ?  <label>{data.label}</label> : null}
                
                <h1 className="heading">{data.title}</h1>
                <p>{data.description}</p>
                <span className="free-trial">21 Days Free Trial | No Credit Card Required</span>
                <button onClick={() => dispatch(openPopup())} className="default-btn">{data.btn}</button>
              </div>
            </div>

            <div className="col-lg-6 col-md-6">
              <div className="blabla-head-image">
                <img src={data.image} alt="BlaBlaCar Clone App" className="img-responsive" />
              </div>
            </div>
          </div>
        </div>
        <div className="blabla-banner-animate-box"></div>
      </section>
    </>
  )
}
